module.exports = __webpack_public_path__ + "static/media/sleepearn-logo.d949b53f.jpg";